import { api } from "@/lib/api";

// Stato "tour visto" persistito sul SERVER (per utente), così non riparte su altri dispositivi.
// Cache in memoria per evitare richieste ripetute dai vari PageTour montati.
let cache = null; // Set di chiavi viste
let inflight = null;

export async function getSeenTours() {
  if (cache) return cache;
  if (!inflight) {
    inflight = api.get("/tours/seen")
      .then((r) => { cache = new Set(r.data?.seen || []); return cache; })
      .catch(() => { cache = new Set(); return cache; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

export async function markTourSeen(key) {
  if (!key) return;
  const s = cache || (await getSeenTours());
  s.add(key);
  try { await api.post("/tours/seen", { key }); } catch { /* noop */ }
}

// Da chiamare al logout per non mostrare lo stato di un altro utente.
export function resetTourCache() { cache = null; inflight = null; }
